Pixlee.module('Utilities', function(Utilities, App, Backbone, Marionette, $) {
    // Marionette.Behaviors.behaviorsLookup = App.Behaviors;
    Marionette.Behaviors.behaviorsLookup = function() {
        return App.Behaviors;
    };
});
